import React, { useState, useEffect } from 'react';
import classes from "./personalInfo.module.css";
import InputField from "../../containers/inputField/inputField";
import DoubleArrow from "../../../assets/images/red-arrow.png";
import WhiteArrow from "../../../assets/images/double-arrow.png";

const PersonalInfo = (props) => {
    const [isTermsChecked, setIsTermsChecked] = useState(false);
    const [width, setWidth] = useState(0);
    const [isValid, setIsValid] = useState(false);
    const [controls, setControls] = useState({
        fullName: {
            elementType: "input",
            elementConfig: {
                type: "text",
                placeholder: props.currentLang === 'en' ? "Enter name" : "أدخل الاسم",
            },
            value: props.userData?.basic_info?.full_name || "",
            validation: {
                required: true,
            },
            label: props.currentLang === 'en' ? "Full Name" : "الاسم الكامل",
            valid: false,
            touched: false
        },
        email: {
            elementType: "input",
            elementConfig: {
                type: "email",
                placeholder: props.currentLang === 'en' ? "Enter email" : "أدخل البريد الإلكتروني",
            },
            value: props.userData?.basic_info?.email || "",
            label: props.currentLang === 'en' ? "Email" : "البريد الإلكتروني",
            validation: {
                required: true,
                isEmail: true
            },
            valid: false,
            touched: false
        },
        phone: {
            elementType: "input",
            elementConfig: {
                type: "phone",
                placeholder: "07xxxxxxxx",
                options: []
            },
            value: {    
                dialCode: props.userData?.basic_info?.phone?.slice(0, props.userData?.basic_info?.phone.indexOf(props.userData?.basic_info?.phone.match(/\d/))),
                number: props.userData?.basic_info?.phone?.replace(/[^0-9]/g, ""),
            } || "",
            valueName: "phone_number",
            validation: {
                required: true,
                isNumeric: true
            },
            label: props.currentLang === 'en' ? "Phone Number" : "رقم الهاتف",
            valid: false,
            touched: false
        },
    });
    const handleResize = () => setWidth(window.innerWidth);
    useEffect(() => {
        setWidth(window.innerWidth)
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        }
    }, []);

    // Update labels and placeholders when language changes
    useEffect(() => {
        setControls({
            ...controls,
            fullName: {
                ...controls.fullName,
                elementConfig: {
                    ...controls.fullName.elementConfig,
                    placeholder: props.currentLang === 'en' ? "Enter name" : "أدخل الاسم",
                },
                label: props.currentLang === 'en' ? "Full Name" : "الاسم الكامل"
            },
            email: {
                ...controls.email,
                elementConfig: {
                    ...controls.email.elementConfig,
                    placeholder: props.currentLang === 'en' ? "Enter email" : "أدخل البريد الإلكتروني",
                },
                label: props.currentLang === 'en' ? "Email" : "البريد الإلكتروني"
            },
            phone: {
                ...controls.phone,
                label: props.currentLang === 'en' ? "Phone Number" : "رقم الهاتف"
            }
        });
    }, [props.currentLang]);

    const formElementsArray = [];
    for (let key in controls) {
        formElementsArray.push({
            id: key,
            config: controls[key]
        });
    }
    const form = formElementsArray.map((formElement, i) => (
        <div key={i} className={classes.FormGroup}>
            <InputField
                key={formElement.id}
                elementType={formElement.config.elementType}
                elementConfig={formElement.config.elementConfig}
                value={formElement.config.value}
                invalid={!formElement.config.valid}
                shouldValidate={formElement.config.validation}
                touched={formElement.config.touched}
                withRemove={false}
                label={formElement.config.label}
                changed={event => inputChangedHandler(event, formElement.id)}
            />
        </div>
    ));
    const checkValidity = ((value, rules) => {
        let isValid = true;
        if (!rules) {
            return true;
        }

        if (rules.required) {
            value = typeof value === 'string' ? value.trim() : value;
            isValid = value !== "" && isValid;
        }

        if (rules.isEmail) {
            const pattern = /[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?/;
            isValid = pattern.test(value) && isValid;
        }

        if (rules.isNumeric) {
            const pattern = /^\d+$/;
            isValid = pattern.test(value) && isValid;
        }

        return isValid;
    })
    const inputChangedHandler = (event, controlName) => {
        const value = (controlName === 'phone') ? event : event.target.value;
        const updatedControls = {
            ...controls,
            [controlName]: {
                ...controls[controlName],
                value,
                valid: checkValidity(value, controls[controlName].validation),
                touched: true
            }
        };
        setControls(updatedControls);
    };
    const clearControls = () => {
        const updatedControls = {
            ...controls
        };
        for (let key in controls) {
            updatedControls[key] = {
                ...controls[key],
                value: "",
                valid: false,
                touched: false
            };
        }
        setControls(updatedControls);
    };
    const submitHandler = e => {
        e.preventDefault();
        const formData = {
            contact_name: controls.fullName.value,
            contact_email: controls.email.value,
            contact_phone: controls.phone.value.dialCode+controls.phone.value.number
        }        
        props.fieldBooking(formData);
        localStorage.setItem("PersonalData", JSON.stringify(formData));
    };
    const backHandler = () => {
        props.setCurrentStep(props.currentStep - 1) 
        window.scrollTo({ top: 0, behavior: 'smooth' })
    }
    return (
        <form className={classes.Container} onSubmit={(e) => submitHandler(e)}>
            {form}
            <p className={classes.Prompt}>
                {props.currentLang === 'en' 
                    ? 'Please read and agree to our '
                    : 'يرجى قراءة والموافقة على '}
                <a href="/privacy-policy" target='_blank' className={classes.Link}>
                    {props.currentLang === 'en' ? 'Privacy Policy' : 'سياسة الخصوصية'}
                </a>
                {props.currentLang === 'en' ? ' and ' : ' و'}
                <a href="/terms-and-conditions" target='_blank' className={classes.Link}>
                    {props.currentLang === 'en' ? 'Terms' : 'الشروط والأحكام'}
                </a>
            </p>
            <div className={classes.CheckBox}>
                <input type="checkbox" onClick={() => setIsTermsChecked(!isTermsChecked)} />
                <label className={classes.Label}>
                    {props.currentLang === 'en' 
                        ? 'I have read and agreed to terms and conditions and privacy policy'
                        : 'لقد قرأت ووافقت على الشروط والأحكام وسياسة الخصوصية'}
                </label>
            </div>
            <div className={classes.Buttons}>
                <button onClick={backHandler}>
                    {props.currentLang === 'en' ? (
                        <>
                            <img
                                src={DoubleArrow}
                                alt=""
                                className={classes.Icon}
                            /> BACK
                        </>
                    ) : (
                        <>
                            <img
                                src={DoubleArrow}
                                alt=""
                                className={[classes.Icon, classes.FlipArrow].join(" ")}
                            /> رجوع
                        </>
                    )}
                </button>
                <button type='submit'
                    className={[classes.Next, !isTermsChecked && classes.Disabled].join(" ")} 
                    disabled={!isTermsChecked}>
                    {props.currentLang === 'en' ? (
                        <>
                            NEXT <img
                                src={WhiteArrow}
                                alt=""
                                className={classes.Icon}
                            />
                        </>
                    ) : (
                        <>
                            التالي <img
                                src={WhiteArrow}
                                alt=""
                                className={[classes.Icon, classes.FlipArrow].join(" ")}
                            />
                        </>
                    )}
                </button>
            </div>
        </form>
    )
}
export default PersonalInfo;